import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "audiosContainer"
};
const _hoisted_2 = {
  class: "exhibition-img"
};
const _hoisted_3 = {
  key: 0,
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 1,
  class: "singleImage"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "viewNum type"
};
const _hoisted_10 = {
  class: "bottomContainer"
};
const _hoisted_11 = {
  class: "exhibition-container"
};
const _hoisted_12 = {
  key: 0,
  class: "changeLanguage"
};
const _hoisted_13 = {
  class: "exhibition-box"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  key: 0,
  class: "type"
};
const _hoisted_16 = {
  class: "number"
};
const _hoisted_17 = {
  class: "audio"
};
const _hoisted_18 = {
  class: "slider"
};
const _hoisted_19 = {
  class: "nowTime"
};
const _hoisted_20 = {
  class: "exhibiton-content"
};
const _hoisted_21 = {
  key: 1,
  class: "navSwitch"
};
const _hoisted_22 = {
  class: "label"
};
const _hoisted_23 = {
  class: "name"
};
const _hoisted_24 = {
  class: "label"
};
const _hoisted_25 = {
  class: "name"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  key: 2,
  ref: "listaudioItem",
  id: "listaudio",
  preload: "auto"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "recommend"
};
const _hoisted_30 = {
  class: "recommend-title"
};
const _hoisted_31 = {
  class: "titleWarp"
};
const _hoisted_32 = {
  class: "recom-title"
};
const _hoisted_33 = {
  class: "swiper swiper-container",
  ref: "recommonedSwiper"
};
const _hoisted_34 = {
  class: "swiper-wrapper"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["src"];
const _hoisted_37 = {
  class: "name"
};
const _hoisted_38 = {
  class: "txtbox"
};
const _hoisted_39 = {
  class: "audio-menuv2"
};
const _hoisted_40 = ["innerHTML"];
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  key: 0,
  class: "exhibition-address"
};
const _hoisted_43 = {
  class: "number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guideTheme = _resolveComponent("guideTheme");
  const _component_van_slider = _resolveComponent("van-slider");
  const _component_guideBottom = _resolveComponent("guideBottom");
  const _component_hysbwg = _resolveComponent("hysbwg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioDetail ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudio' : ''} ${$data.imgContainFids.indexOf(_ctx.$route.query.fid) > -1 ? 'imgContain' : ''}`),
    onTouchstart: _cache[16] || (_cache[16] = (...args) => $options.touchstart && $options.touchstart(...args))
  }, [_createVNode(_component_guideTheme), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["topcontainer", {
      'noImg': $data.imgList.length === 0
    }])
  }, [_createElementVNode("div", _hoisted_2, [$data.imgList.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      src: item,
      class: "no-save-img"
    }, null, 8, _hoisted_6)]);
  }), 256))]), _cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 512)) : $data.imgList.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
    src: $data.imgList[0],
    class: "no-save-img"
  }, null, 8, _hoisted_8)])) : _createCommentVNode("", true)]), $data.antiqueDetail.viewNum && _ctx.$route.query.fid != 342576 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_cache[18] || (_cache[18] = _createElementVNode("i", {
    class: "icon-view"
  }, null, -1)), _createElementVNode("span", null, _toDisplayString($data.antiqueDetail.viewNum), 1)])) : _createCommentVNode("", true), ($data.antiqueDetail.likeNum || $data.antiqueDetail.likeNum === '0') && _ctx.$route.query.fid != 342576 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["likebtn type", {
      'on': $data.isLiked
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.editFormData(2))
  }, [_cache[19] || (_cache[19] = _createElementVNode("i", {
    class: "icon-like"
  }, null, -1)), _createElementVNode("span", null, _toDisplayString($data.antiqueDetail.likeNum), 1)], 2)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$data.antiqueDetail.en_explainObj || $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
    class: _normalizeClass(!_ctx.language && !$data.languageType || $data.languageType == 1 ? 'active' : ''),
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.changeLanguage(1), ["self"]))
  }, "普通话", 2), $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($data.languageType == 2 ? 'active' : ''),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.changeLanguage(2), ["self"]))
  }, _toDisplayString($data.antiqueDetail.fangyanleixing), 3)) : _createCommentVNode("", true), $data.antiqueDetail.en_explainObj ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(_ctx.language && !$data.languageType || $data.languageType == 3 ? 'active' : ''),
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.changeLanguage(3), ["self"]))
  }, "English", 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("div", {
    class: "linkUrl type",
    onClick: _cache[4] || (_cache[4] = _withModifiers($event => $options.openUrl($data.antiqueDetail.zhishituozhan), ["stop"]))
  }, _toDisplayString(_ctx.$route.query.fid == 47792 ? '3D 展示' : '知识拓展'), 513), [[_vShow, $data.antiqueDetail.zhishituozhan && !_ctx.language]]), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.language ? $data.antiqueDetail.en_explainObj : $data.antiqueDetail.explainObj), 1), !$data.hasChangeLanguage ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_cache[20] || (_cache[20] = _createElementVNode("i", {
    class: "icon-address"
  }, null, -1)), _createElementVNode("span", _hoisted_16, _toDisplayString(!$data.hasChangeLanguage ? $data.location : ''), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString($data.nowTime), 1), _createVNode(_component_van_slider, {
    "active-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    "inactive-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    modelValue: $data.ctTime,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.ctTime = $event),
    "bar-height": "4px",
    "button-size": "7.5px",
    max: $data.maxValue,
    style: {
      "margin": "0 0.3rem"
    },
    disabled: !$data.hasPalyed,
    onDragStart: $options.startMove,
    onChange: $options.changeTime
  }, null, 8, ["active-color", "inactive-color", "modelValue", "max", "disabled", "onDragStart", "onChange"]), _createElementVNode("span", {
    class: _normalizeClass(`totalTime ${!$data.totalTime ? 'timaLoading' : ''}`)
  }, _toDisplayString($data.totalTime), 3)]), _createElementVNode("div", {
    onClick: _cache[8] || (_cache[8] = (...args) => $options.clickPlay && $options.clickPlay(...args)),
    class: "play"
  }, [_createElementVNode("div", {
    class: "back",
    onClick: _cache[6] || (_cache[6] = $event => $options.changePlayTime(-1))
  }), _createElementVNode("i", {
    class: _normalizeClass($data.isPlaying ? 'icon-pause' : 'icon-video1')
  }, null, 2), _createElementVNode("div", {
    class: "go",
    onClick: _cache[7] || (_cache[7] = $event => $options.changePlayTime(1))
  })])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
    id: "desc",
    class: _normalizeClass(`txtcon ${$data.isFolded && $data.descflag ? 'hide' : ''}`)
  }, _cache[21] || (_cache[21] = [_createElementVNode("div", {
    class: "richtext",
    id: "editor1"
  }, null, -1)]), 2), _withDirectives(_createElementVNode("div", {
    onClick: _cache[9] || (_cache[9] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '展开全部'}` : `${this.language ? 'up' : '收起'}`), 1), _createElementVNode("i", {
    class: _normalizeClass(["icon-arrow-bottom1", {
      'up': !$data.isFolded
    }])
  }, null, 2)], 2), [[_vShow, $data.descflag]])]), $options.prevItem || $options.nextItem ? (_openBlock(), _createElementBlock("div", _hoisted_21, [$options.prevItem ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "navBtn prev",
    onClick: _cache[10] || (_cache[10] = $event => $options.toDetail($options.prevItem))
  }, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.language ? 'Prev' : '上一件') + "  ", 1), _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language ? $options.prevItem.en_explainObj : $options.prevItem.explainObj), 1)])) : _createCommentVNode("", true), $options.nextItem ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "navBtn next",
    onClick: _cache[11] || (_cache[11] = $event => $options.toDetail($options.nextItem))
  }, [_createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language ? 'Next' : '下一件') + "  ", 1), _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.language ? $options.nextItem.en_explainObj : $options.nextItem.explainObj), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), $data.audioPath ? (_openBlock(), _createElementBlock("audio", {
    key: 1,
    ref: "audioItem",
    id: "audio",
    preload: "auto",
    onCanplay: _cache[12] || (_cache[12] = $event => $options.getDuration('audioItem')),
    onTimeupdate: _cache[13] || (_cache[13] = (...args) => $options.handleAudioTimeUpdate && $options.handleAudioTimeUpdate(...args)),
    onLoadedmetadata: _cache[14] || (_cache[14] = (...args) => _ctx.onLoadedmeta && _ctx.onLoadedmeta(...args))
  }, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_26)], 544)) : _createCommentVNode("", true), $data.listaudioPath ? (_openBlock(), _createElementBlock("audio", _hoisted_27, [_createElementVNode("source", {
    src: $data.listaudioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_28)], 512)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[22] || (_cache[22] = _createElementVNode("span", {
    class: "line"
  }, null, -1)), _createElementVNode("span", _hoisted_32, _toDisplayString(this.language ? 'recommend' : '推荐'), 1)]), _createElementVNode("div", {
    onClick: _cache[15] || (_cache[15] = (...args) => $options.replace && $options.replace(...args)),
    class: "replace"
  }, _toDisplayString(this.language ? 'change' : '换一换'), 1)]), _createElementVNode("div", {
    class: _normalizeClass(`recommendList ${_ctx.$route.query.fid == 332724 ? 'bigImg' : ''}`)
  }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommendList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-image swiper-slide",
      key: index,
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("div", {
      class: _normalizeClass(["imgbox", {
        'noImg': !item.littleImage
      }])
    }, [item.littleImage ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.littleImage
    }, null, 8, _hoisted_36)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.language ? item.en_explainObj : item.explainObj), 1)], 2), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
      class: "duration",
      innerHTML: item.intro
    }, null, 8, _hoisted_40), item.audioPath ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _withModifiers($event => $options.listclickPlay(index, item), ["stop"]),
      class: "play"
    }, [_createElementVNode("i", {
      class: _normalizeClass($data.islistPlaying && $data.currentIndex === index ? 'icon-pause' : 'icon-video1')
    }, null, 2)], 8, _hoisted_41)) : _createCommentVNode("", true)]), $options.getAddress(item) ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_cache[23] || (_cache[23] = _createElementVNode("i", {
      class: "icon-address"
    }, null, -1)), _createElementVNode("span", _hoisted_43, _toDisplayString($options.getAddress(item)), 1)])) : _createCommentVNode("", true)])], 8, _hoisted_35);
  }), 128))])], 512)], 2)])])]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true), _createVNode(_component_hysbwg, {
    name: "audioDetailv2",
    type: "audio"
  })], 34);
}